import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
// 【新增】商品图片画廊组件
interface ProductImageGalleryProps {
  images: string | string[] | undefined;
  alt: string;
}

const ProductImageGallery: React.FC<ProductImageGalleryProps> = ({ images, alt }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageList, setImageList] = useState<string[]>([]);

  useEffect(() => {
    let urls: string[] = [];
    if (!images) {
      urls = ['https://via.placeholder.com/600'];
    } else if (Array.isArray(images)) {
      urls = images.length > 0 ? images : ['https://via.placeholder.com/600'];
    } else if (typeof images === 'string') {
      const split = images.split(',').map(u => u.trim()).filter(u => u);
      urls = split.length > 0 ? split : ['https://via.placeholder.com/600'];
    }
    setImageList(urls);
    setCurrentIndex(0);
  }, [images]);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % imageList.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + imageList.length) % imageList.length);
  };

  const goToImage = (index: number) => {
    setCurrentIndex(index);
  };

  if (imageList.length === 0) return null;

  const currentSrc = imageList[currentIndex];

  return (
    <div className="relative aspect-square bg-gray-100 rounded-xl overflow-hidden group">
      {/* 主图 */}
      <img
        src={currentSrc}
        alt={`${alt} - 图片 ${currentIndex + 1}`}
        className="w-full h-full object-cover transition-opacity duration-300"
      />

      {/* 左右切换按钮 - 仅在多张图片时显示 */}
      {imageList.length > 1 && (
        <>
          <button
            onClick={(e) => { e.preventDefault(); prevImage(); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 hover:bg-white text-gray-800 rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 backdrop-blur-sm"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={(e) => { e.preventDefault(); nextImage(); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 hover:bg-white text-gray-800 rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 backdrop-blur-sm"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          {/* 底部指示器/缩略图条 */}
          <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 px-4">
            {imageList.map((_, idx) => (
              <button
                key={idx}
                onClick={(e) => { e.preventDefault(); goToImage(idx); }}
                className={`h-2 rounded-full transition-all duration-300 ${
                  idx === currentIndex 
                    ? 'w-8 bg-[#1c5bff]' 
                    : 'w-2 bg-white/60 hover:bg-white'
                }`}
                aria-label={`查看第 ${idx + 1} 张图片`}
              />
            ))}
          </div>
          
          {/* 图片计数 */}
          <div className="absolute top-4 right-4 px-2 py-1 bg-black/50 text-white text-xs rounded-md backdrop-blur-sm">
            {currentIndex + 1} / {imageList.length}
          </div>
        </>
      )}
    </div>
  );
};
export default ProductImageGallery;